import { FormValues, propertySchema } from "./form";
import { useFormContext } from "react-hook-form";

export const usePropertyStep = () => {
  const methods = useFormContext<FormValues>();

  const validatePropertyStep = async () => {
    const values = methods.getValues();
    const result = await propertySchema.safeParseAsync(values);

    if (!result.success) {
      const fieldErrors = result.error.flatten().fieldErrors;

      // エラーを React Hook Form に反映
      Object.entries(fieldErrors).forEach(([key, messages]) => {
        if (messages && messages.length > 0) {
          methods.setError(key as keyof FormValues, {
            type: "manual",
            message: messages[0],
          });
        }
      });

      return false;
    }

    return true;
  };

  return {
    validatePropertyStep,
  };
};
